import { PropsWithChildren, useRef } from 'react'
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'

import { getPostHogApiHost } from '@percent/utility'

export function PostHogProvider({ children }: PropsWithChildren) {
  const apiKey = process.env.NX_PUBLIC_POSTHOG_API_KEY
  const initialised = useRef(false)

  // Init in render, not a useEffect: that raced the first step_viewed and dropped it. The
  // ref keeps init to one call.
  if (apiKey && !initialised.current) {
    initialised.current = true

    posthog.init(apiKey, {
      api_host: getPostHogApiHost(window.location.hostname),
      ui_host: 'https://eu.posthog.com',
      capture_pageview: false,
      autocapture: false,
      person_profiles: 'identified_only',
      disable_session_recording: true,
      // Run fully cookieless: never store anything client-side (no cookies,
      // no localStorage). Identity is a server-side daily hash, so no consent
      // banner is required.
      cookieless_mode: 'always',
      capture_performance: {
        web_vitals: true,
        web_vitals_allowed_metrics: ['LCP', 'FCP', 'INP']
      }
    })
    posthog.register({ app: 'education-hosted-form' })
  }

  if (!apiKey) {
    // eslint-disable-next-line no-console
    console.warn(
      'PostHog API key missing. Feature flags will use their configured defaults and user analytics will be missing.'
    )

    return <>{children}</> // eslint-disable-line react/jsx-no-useless-fragment -- children is ReactNode; fragment normalises the return type
  }

  return <PHProvider client={posthog}>{children}</PHProvider>
}
